<template>
  <div class="about">

    <section id="portada" class="animacion">
        <div class="contedor-portada">
          <div class="portada-contenido animacion">
          <h1>{{nom_sub_sec_es}}</h1>
          <ul>
            <li><router-link tag="a" to="/">Inicio</router-link></li>
            <li class="sin-division">{{nom_sub_sec_es}}</li>
          </ul>
          </div>
          <img
            class="imagen-cover"
            v-bind:src='imgPreUrl+ url_1st_image +"x640.jpg"'
            v-bind:alt='type_1st_image'>
        </div>
    </section>

    <section id="servicios" class="secciones seccion-blanca">        
      <div class="container">
        <h1>{{internal_name_es}}</h1>
        <span v-html="desc_sub_section_es"></span>
        <hr>
        <!--  Mapa  -->
          <div class="contacto-mapa">
            <br>
            <div class="row">
              <div class="col-md-12" v-for="(item, index) in item_list" :key="item.id_item" style="padding-bottom: 55px;">
                <div class="row">
                  <div class="col-sm-12 col-lg-6">
                    <div class="contacto-mapa-lugar">
                      <h2>{{ item.title_item_es }}</h2>
                      <span v-html="item.desc_item_es"></span>
                    </div>
                  </div>
                  <div class="col-sm-12 col-lg-6">

                    <!--
                    <div class="mapa">
                      <div :id="index == 0 ? 'google_canvas' : 'google_canvas' + (index + 1)" style="width: 100%; height: 100%;"></div>
                    </div>
                    -->
                      

                        <br>
                         <div :id="'carouselExampleIndicators'+index" class="carousel slide" data-ride="carousel">

                         
                          <ol class="carousel-indicators">
                            <template v-for="(image_gallery,imageindex) in item.url_image.split(',')">
                              <li :data-target="'#carouselExampleIndicators'+index" :data-slide-to="imageindex" :class="imageindex==0? 'active' : ''"  v-bind:key='imageindex'></li>
                            </template>
                          </ol>
                         
                         
                          <div class="carousel-inner">
                            <template v-for="(image_gallery,imageindex) in item.url_image.split(',')">

                              <div :class="imageindex==0? 'carousel-item active' : 'carousel-item'" v-bind:key='imageindex'>
                                <div class="mapa" style="overflow: unset;">
                                  <img class="d-block w-100" v-bind:src='imgPreUrl+ image_gallery +"x640.jpg"' alt="First slide">
                                </div>
                              </div>

                            </template>
                          </div>
                          <a class="carousel-control-prev" :href="'#carouselExampleIndicators'+index" role="button" data-slide="prev">
                            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                            <span class="sr-only">Previous</span>
                          </a>
                          <a class="carousel-control-next" :href="'#carouselExampleIndicators'+index" role="button" data-slide="next">
                            <span class="carousel-control-next-icon" aria-hidden="true"></span>
                            <span class="sr-only">Next</span>
                          </a>
                        </div>
                    
                  </div>
                </div>
                
                
              </div>

            </div>
          </div>
      </div>
    </section>
    

    <!--
    <section id="contacto-mapa" class="animacion">
      <div class="mapa">
             <GmapMap
            :center="{lat:-12.0581801, lng:-77.1346098}"   
            :zoom="12"
            style="width: 100%; height: 100%"
            :options="options"
             >
            <gmap-marker v-for="(item, key) in coordinates" :key="key" :position="getPosition(item)" :clickable="true" @click="toggleInfo(item, key)" />
            </GmapMap>
      </div>
      <div class="contacto-mapa-contenido animacion">
          <span v-html="text1_es"></span>
      </div>   
    </section>
    -->

    <TwoModules></TwoModules>
    <NewModules></NewModules>

  </div>

</template>


<style lang="scss">
.about {
  @media(min-width:992px) {
     padding-top: 103px;
  }
}
.avatar {
  border-radius: 10px;
}
.row-height2 {
  background-color: #e5e5ea;
  border-radius: 15px 15px 15px 15px;
}
</style>

<script>
import TwoModules from "@/components/products/TwoModules.vue";
import NewModules from "@/components/products/NewModule.vue";
import axios from "axios";
import {config_settings} from '../config.js';
import _ from "lodash";
import { errorToaster } from '../components/shared/service/ErrorHandler';

//HTTP ERROR STATUS
  const NOT_FOUND = 404;
  const BAD_REQUEST = 400;
  const UNAUTHORIZED = 401;
  const INTERNAL_SERVER_ERROR = 500;

  axios.interceptors.response.use(function (response) { return response; }, 
  function (error) {
    
    if(error.message === 'Network Error'){
      toastr.error("No se puede conectar con el servidor. Verifique su conexión a internet",
                       "ERROR",
                       {"iconClass": 'customer-danger'});
    }
    else if(error.response.status === UNAUTHORIZED){
      if(error.response.data.message === "Access is denied"){
         toastr.error("Usted no tiene los provilegios para acceder a esta sección",
                       "ERROR",
                       {"iconClass": 'customer-danger'});
      }
      else {
        return Promise.reject(error);
      }
    }
    else {
      return Promise.reject(error);
    }
});

export default {
  components: {
    TwoModules,
    NewModules
  },
  data() {
    return {
      page_title: "",
      page_description: "",
      page_keywords: "",

    imgPreUrl : config_settings.PHOTO_SERVER_URL+'/',
    cod_sub_sec: 11,
    nom_sub_sec_es: '',
    nom_sub_sec_en: '',
    internal_name_es: '',
    internal_name_en: '',
    desc_sub_section_es: '',
    desc_sub_section_en: '',
    section: '',
    url_1st_image: 'products/empty-img',
    url_2nd_image: 'products/empty-img',
    url_3rd_image: 'products/empty-img',
    url_4th_image: 'products/empty-img',
    url_5th_image: 'products/empty-img',
    type_1st_image: 'image',
    type_2nd_image: 'image',
    type_3rd_image: 'image',
    type_4th_image: 'image',
    type_5th_image: 'image',
    text1_es: '',
    text1_en: '',
    text2_es: '',
    text2_en: '',
    text3_es: '',
    text3_en: '',
    orientation: '',
    url_es: '',
    url_en: '',
    order_sub_section: '',
    id_position_menu: '',
    url_video: '',
    type: '',
    coordinates: {
      0: {
        full_name: 'Armaq San Isidro',
        lat: '-12.099830',
        lng: '-77.019745'
      },
      1: {
        full_name: 'Armaq Jockey Plaza',
        lat: '-12.086355',
        lng: '-76.977085'
      },
      2: {
        full_name: 'Armaq Plaza Norte',
        lat: '-12.006168',
        lng: '-77.058908'
      },
      3: {
        full_name: 'Armaq Piura',
        lat: '-5.192881',
        lng: '-80.639651'
      }
    },
    options: {
           disableDefaultUI: true,
           scrollwheel: false,
           styles:  [
          {
            "elementType": "geometry",
            "stylers": [
              {
                "color": "#1d2c4d"
              }
            ]
          },
          {
            "elementType": "labels.text.fill",
            "stylers": [
              {
                "color": "#8ec3b9"
              }
            ]
          },
          {
            "elementType": "labels.text.stroke",
            "stylers": [
              {
                "color": "#1a3646"
              }
            ]
          },
          {
            "featureType": "administrative.country",
            "elementType": "geometry.stroke",
            "stylers": [
              {
                "color": "#4b6878"
              }
            ]
          },
          {
            "featureType": "administrative.land_parcel",
            "elementType": "labels.text.fill",
            "stylers": [
              {
                "color": "#64779e"
              }
            ]
          },
          {
            "featureType": "administrative.province",
            "elementType": "geometry.stroke",
            "stylers": [
              {
                "color": "#4b6878"
              }
            ]
          },
          {
            "featureType": "landscape.man_made",
            "elementType": "geometry.stroke",
            "stylers": [
              {
                "color": "#334e87"
              }
            ]
          },
          {
            "featureType": "landscape.natural",
            "elementType": "geometry",
            "stylers": [
              {
                "color": "#023e58"
              }
            ]
          },
          {
            "featureType": "poi",
            "elementType": "geometry",
            "stylers": [
              {
                "color": "#283d6a"
              }
            ]
          },
          {
            "featureType": "poi",
            "elementType": "labels.text.fill",
            "stylers": [
              {
                "color": "#6f9ba5"
              }
            ]
          },
          {
            "featureType": "poi",
            "elementType": "labels.text.stroke",
            "stylers": [
              {
                "color": "#1d2c4d"
              }
            ]
          },
          {
            "featureType": "poi.business",
            "stylers": [
              {
                "visibility": "off"
              }
            ]
          },
          {
            "featureType": "poi.park",
            "elementType": "geometry.fill",
            "stylers": [
              {
                "color": "#023e58"
              }
            ]
          },
          {
            "featureType": "poi.park",
            "elementType": "labels.text",
            "stylers": [
              {
                "visibility": "off"
              }
            ]
          },
          {
            "featureType": "poi.park",
            "elementType": "labels.text.fill",
            "stylers": [
              {
                "color": "#3C7680"
              }
            ]
          },
          {
            "featureType": "road",
            "elementType": "geometry",
            "stylers": [
              {
                "color": "#304a7d"
              }
            ]
          },
          {
            "featureType": "road",
            "elementType": "labels.text.fill",
            "stylers": [
              {
                "color": "#98a5be"
              }
            ]
          },
          {
            "featureType": "road",
            "elementType": "labels.text.stroke",
            "stylers": [
              {
                "color": "#1d2c4d"
              }
            ]
          },
          {
            "featureType": "road.arterial",
            "elementType": "labels",
            "stylers": [
              {
                "visibility": "off"
              }
            ]
          },
          {
            "featureType": "road.highway",
            "elementType": "geometry",
            "stylers": [
              {
                "color": "#2c6675"
              }
            ]
          },
          {
            "featureType": "road.highway",
            "elementType": "geometry.stroke",
            "stylers": [
              {
                "color": "#255763"
              }
            ]
          },
          {
            "featureType": "road.highway",
            "elementType": "labels",
            "stylers": [
              {
                "visibility": "off"
              }
            ]
          },
          {
            "featureType": "road.highway",
            "elementType": "labels.text.fill",
            "stylers": [
              {
                "color": "#b0d5ce"
              }
            ]
          },
          {
            "featureType": "road.highway",
            "elementType": "labels.text.stroke",
            "stylers": [
              {
                "color": "#023e58"
              }
            ]
          },
          {
            "featureType": "road.local",
            "stylers": [
              {
                "visibility": "off"
              }
            ]
          },
          {
            "featureType": "transit",
            "elementType": "labels.text.fill",
            "stylers": [
              {
                "color": "#98a5be"
              }
            ]
          },
          {
            "featureType": "transit",
            "elementType": "labels.text.stroke",
            "stylers": [
              {
                "color": "#1d2c4d"
              }
            ]
          },
          {
            "featureType": "transit.line",
            "elementType": "geometry.fill",
            "stylers": [
              {
                "color": "#283d6a"
              }
            ]
          },
          {
            "featureType": "transit.station",
            "elementType": "geometry",
            "stylers": [
              {
                "color": "#3a4762"
              }
            ]
          },
          {
            "featureType": "water",
            "elementType": "geometry",
            "stylers": [
              {
                "color": "#0e1626"
              }
            ]
          },
          {
            "featureType": "water",
            "elementType": "labels.text.fill",
            "stylers": [
              {
                "color": "#4e6d70"
              }
            ]
          }
        ]
    },
    
    item_list: []
   }
  },

  updated() {
    this.load_map()
  },

  metaInfo() {

        return {
             title:  this.page_title ? this.page_title : "",
             meta: [
              { name: 'description', content: this.page_description ? this.page_description : "" },
              { name: 'keywords', content: this.page_keywords ? this.page_keywords : "" },
              { name: 'robots', content: "index" }
            ]
        }
  },
  
  methods: {
      animation(marcador) {
        if (marcador.getAnimation() != null) {
          marcador.setAnimation(null);
        } else {
          marcador.setAnimation(google.maps.Animation.BOUNCE);
          setTimeout(function(){ marcador.setAnimation(null); }, 750);
        }
      },

      add_markers(mapa, coordenadas) {
        var marcador = null
        var marcador = new google.maps.Marker({
          map: mapa,
          draggable: false,
          position: new google.maps.LatLng(coordenadas[0], coordenadas[1]),
          visible:true,
          title:"Transmeridian",
          animation: google.maps.Animation.DROP
        });

        marcador.setIcon('/favicon.png');
        google.maps.event.addListener(marcador, 'click', function() {
          if (marcador.getAnimation() != null) {
            marcador.setAnimation(null);
          } else {
            marcador.setAnimation(google.maps.Animation.BOUNCE);
            setTimeout(function(){ marcador.setAnimation(null); }, 750);
          }
        });
      },

      load_map() {
        this.item_list.forEach ((item, index) => {
          let coordenadas = item.prev_desc_item_es.split("|")
          let options = {
            zoom: 17,
            center: new google.maps.LatLng(coordenadas[0], coordenadas[1]),
            scrollwheel: false,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            styles: [{"featureType":"all","elementType":"all","stylers":[{"gamma":"0.70"},{"lightness":"-5"},{"saturation":"30"},{"weight":"1.2"},{"hue":"#00acff"},{"visibility":"on"}]},{"featureType":"all","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"administrative","elementType":"all","stylers":[{"saturation":"0"},{"lightness":"-10"}]},{"featureType":"administrative","elementType":"labels","stylers":[{"visibility":"on"}]},{"featureType":"administrative.province","elementType":"labels","stylers":[{"visibility":"on"}]},{"featureType":"landscape","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"poi","elementType":"all","stylers":[{"visibility":"on"}]},{"featureType":"poi","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"road","elementType":"all","stylers":[{"visibility":"on"}]},{"featureType":"transit","elementType":"all","stylers":[{"visibility":"simplified"}]},{"featureType":"transit","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"transit.station.airport","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"transit.station.bus","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"transit.station.rail","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"water","elementType":"all","stylers":[{"visibility":"on"}]},{"featureType":"water","elementType":"geometry.fill","stylers":[{"color":"#161616"}]},{"featureType":"water","elementType":"labels","stylers":[{"visibility":"off"}]}]
          }

          if(this.item_list.length == 1) { var mapa = new google.maps.Map(document.getElementById('google_canvas'), options); }
          else {
            var mapa = null
            if(index == 0) { mapa = new google.maps.Map(document.getElementById('google_canvas'), options); }
            else { mapa = new google.maps.Map(document.getElementById('google_canvas'+ (index + 1)), options); } 
          }

          this.add_markers(mapa, coordenadas)
          console.log(document.getElementById('google_canvas'+ (index + 1)))
        })
      },

      obtener_items() {
        axios.get(config_settings.RESOURCE_SERVER_URL+ '/GET/sub_sections/'+ this.cod_sub_sec +'/items_all')
        .then(response => {
          this.item_list = response.data
          console.log(this.item_list)
        })
        .catch(error => {
          //console.log(error)
        })
      },
      
    obtener_sub_section_data(){
      axios.get(config_settings.RESOURCE_SERVER_URL+ '/GET/sub_sections/'+ this.cod_sub_sec)
           .then(response => {
              
              this.nom_sub_sec_es = response.data.nom_sub_sec_es
              this.nom_sub_sec_en = response.data.nom_sub_sec_en
              this.internal_name_es = response.data.internal_name_es
              this.internal_name_en  = response.data.internal_name_en  
              this.desc_sub_section_es = response.data.desc_sub_section_es  
              this.desc_sub_section_en = response.data.desc_sub_section_en  
              this.section = response.data.section  
              this.url_1st_image = response.data.url_1st_image  
              this.url_2nd_image = response.data.url_2nd_image  
              this.url_3rd_image = response.data.url_3rd_image  
              this.url_4th_image = response.data.url_4th_image  
              this.url_5th_image = response.data.url_5th_image  
              this.type_1st_image = response.data.type_1st_image  
              this.type_2nd_image = response.data.type_2nd_image  
              this.type_3rd_image = response.data.type_3rd_image  
              this.type_4th_image = response.data.type_4th_image  
              this.type_5th_image = response.data.type_5th_image  
              this.text1_es = response.data.text1_es  
              this.text1_en = response.data.text1_en 
              this.text2_es = response.data.text2_es  
              this.text2_en = response.data.text2_en  
              this.text3_es = response.data.text3_es  
              this.text3_en = response.data.text3_en  
              this.orientation = response.data.orientation  
              this.url_es = response.data.url_es  
              this.url_en = response.data.url_en  
              this.order_sub_section = response.data.order_sub_section  
              this.id_position_menu = response.data.id_position_menu  
              this.url_video = response.data.url_video 
              this.type = response.data.type 

               //SEO
              this.page_title = this.nom_sub_sec_es;
              this.page_description = this.desc_sub_section_es;
              this.page_keywords = response.data.keywords;
              
             
          })
           .catch(error => {
            console.log("error");
      })
    },

    scroll_inicio() {
      window.scrollTo(0,0);
    },

    getPosition: function(marker) {
      return {
        lat: parseFloat(marker.lat),
        lng: parseFloat(marker.lng)
      }
    },

    toggleInfo: function(marker, key) {
      this.infoPosition = this.getPosition(marker)
      this.infoContent = marker.full_name
      if (this.infoCurrentKey == key) {
        this.infoOpened = !this.infoOpened
      } else {
        this.infoOpened = true
        this.infoCurrentKey = key
      }
    }
  },

  created() {
    this.scroll_inicio();
    this.obtener_sub_section_data();
    this.obtener_items()
  }
};
</script>